import { unwrapResult } from "@reduxjs/toolkit";
import { LoadingButton } from "@mui/lab";
import { Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { Localized } from "@fluent/react";
import { useState } from "react";
import { AppId, APIError } from "../../../../app/appTypes";
import { useAppDispatch } from "../../../../app/hooks";
import { ServerErrorMsg } from "../../../../app/ServerErrorMsg";
import { deleteProjectTeamMember } from "../../projectTeamMembersSlice";

export interface ValidationTeamMemberDeleteDialogProps {
	teamMemberId: AppId;
	onSave: (teamMemberId: AppId) => void;
	onCancel: () => void;
}

export const ValidationTeamMemberDeleteDialog = ({ teamMemberId, onSave, onCancel }: ValidationTeamMemberDeleteDialogProps) => {
	const dispatch = useAppDispatch();
	const [savingInProgress, setSavingInProgress] = useState(false);
	const [error, setError] = useState<APIError | null>(null);

	const handleConfirmDeleteClick = () => {
		setSavingInProgress(true);
		setError(null);
		dispatch(deleteProjectTeamMember(teamMemberId))
			.then(unwrapResult)
			.then(() => onSave(teamMemberId))
			.catch((err: APIError) => setError(err))
			.finally(() => setSavingInProgress(false));
	};

	return <>
		<Dialog open={true} fullWidth maxWidth="md">
			<DialogContent>
				<DialogContentText>
					<Localized id="confirm-delete">
						<span>Czy napewno chcesz usunąć?</span>
					</Localized>
				</DialogContentText>
				<ServerErrorMsg err={error} />
			</DialogContent>
			<DialogActions>
				<LoadingButton loading={savingInProgress} onClick={handleConfirmDeleteClick}>
					<Localized id="yes"><span>Tak</span></Localized>
				</LoadingButton>
				<LoadingButton loading={savingInProgress} onClick={onCancel}>
					<Localized id="no"><span>Nie</span></Localized>
				</LoadingButton>
			</DialogActions>
		</Dialog>
	</>;
};